import React from 'react';
import DailyFeedbackDropdown from '../../UI/DailyFeedbackDropdown/DailyFeedbackDropdown';
import classes from './DailyFeedbackSectionNew.module.css';
import ProgressBar from '../../UI/ProgressBar/ProgressBar';
import { IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import SortHelper from '../../../utilities/SortHelper';
import { GetFromLocalStorage } from '../../../utilities/CommonMethods';
import Constants from '../../../utilities/Constants';
import DailyFeedbackReportCard from '../../DailyFeedbackReportNew/DailyFeedbackReport'
import AreaChart from '../../Charts/AreaChart/AreaChart'
import StackedChart from '../../Charts/StackedChart/StackedChart';
import DropDownModal from '../../UI/DropDownModal/DropDownModal';
import DropDownArrow from '../../../assets/icons/dropdown-blue-arrow.svg';
import StudentResponsePopup from '../../Popups/StudentResponsePopup/StudentResponsePopup';
import FilterIcon from '../../../assets/icons/filter-icon-white.svg';
import FilterDropDown from "../../UI/FilterDropDown/FilterDropDown";
import ShowMiniLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';
class DailyFeedbackSectionNew extends React.PureComponent {

    state = {
        topicsList: [{
            id: 0,
            topicName: 'Loading topics...',
            date: ''
        },],
        activeTopicPos: 0,
        currentTopicId: 0,
        currentUserId: 0,
        feedbackResponses: {
            feedbackAvailable: true,
            subtopics: []
        },
        overallSessionRating: {
            value: '',
            label: 'Overall Session Rating',
            fraction: [0, 0]
        },
        pieChartData: [
            ["Students", "Percentage"],
            ["Completely Understood", 0],
            ["Partially Understood", 0],
            ["Did Not Understand", 0]
        ],
        currentTopicDetails: {
            topicName: 'Loading...',
            date: '',
            responsesReceived: 0,
        },
        studentsList: [],
        fullStudentsList: [],
        feedbackTopicsList: [],
        showTableLoader: true,
        showCardLoader: true,
        showOverallCardLoader: true,
        showStudentsTable: false,

        showNameFilterDropdown: false,
        nameFilterItems: [{ id: 1, label: 'A -> Z' }, { id: 2, label: 'Z -> A' }],
        activeNameFilterDropDownItem: -1,
        nameSearchFieldValue: '',
        isProgramManager: false,
        feedbackType: "",
        durationList: [
            {
                'id': 0,
                'name': "Overall",
                'value': "overall",
            },
            {
                'id': 1,
                'name': "Current Week",
                'value': "current_week",
            },

        ],
        activeItemPos: 1,
        showDurationDropdown: false,

        last7DaysRatings: {},
        last7DaysSessionEngagement: {},
        weeklyRatings: {},
        weeklySessionEngagement: {},

        isLastSessionDataEmpty: true,
        isDailyDataEmpty: true,
        isWeeklyDataEmpty: true,
        showNoteText: false
    }


    onNameFilterClicked = () => {
        let updatedState = this.state.showNameFilterDropdown;
        this.setState({ showNameFilterDropdown: !updatedState });
    }

    onDropDownItemClicked = (pos) => {
        let updatedList = [...this.state.studentsList];

        // -------- Sort by Name --------
        if (pos === 0) {
            updatedList = SortHelper.sortStudentsByName(updatedList, 'ascending');
        } else {
            updatedList = SortHelper.sortStudentsByName(updatedList, 'descending');
        }
        this.setState({
            studentsList: updatedList,
            activeNameFilterDropDownItem: pos,
            showNameFilterDropdown: false
        })
    }

    nameSearchInputChangeHandler = (event) => {
        let updatedValue = event.target.value;
        this.setState({ nameSearchFieldValue: updatedValue });
    }

    onNameSearchIconClick = (searchString) => {
        const updatedSearchString = searchString.toLowerCase();
        const newList = this.state.fullStudentsList.filter(student => {
            if (student.name.toLowerCase().indexOf(updatedSearchString) !== -1) {
                return true;
            }
        });

        if (!IsListEmpty(newList)) {
            this.setState({ studentsList: newList, showNameFilterDropdown: false, nameSearchFieldValue: searchString, activeNameFilterDropDownItem: -1 });
        } else {
            this.props.onFailureDialogShow('No student found with the matching name.', 'OKAY');
        }

    }

    clearSearchResults = () => {
        const updatedList = [...this.state.fullStudentsList];
        this.setState({
            studentsList: updatedList,
            activeNameFilterDropDownItem: -1,
            showNameFilterDropdown: false,
            nameSearchFieldValue: ''
        });
    }

    dropdownItemClicked = (pos) => {
        let updatedCurrentTopic = { ...this.state.topicsList[pos] };
        // console.log(updatedCurrentTopic)
        const currentTopicStartedBy = updatedCurrentTopic.startedBy;
        const currentInstructor = GetFromLocalStorage(Constants.KEY_USERNAME);
        const showNoteText = !IsObjectEmpty(this.state.currentTopicDetails) && !IsStringEmpty(currentTopicStartedBy) && currentTopicStartedBy !== currentInstructor ? true : false;
        // console.log('conditions >>>', currentTopicStartedBy, currentInstructor, showNoteText)

        this.setState({
            activeTopicPos: pos,
            currentTopicDetails: updatedCurrentTopic,
            currentTopicId: updatedCurrentTopic.id,
            feedbackType: updatedCurrentTopic.type,
            showTableLoader: true,
            showCardLoader: true,
            showStudentsTable: false,
            showNoteText: showNoteText
        });


        this.props.setNewURL(updatedCurrentTopic.id);
        this.getDailyFeedbackReportForTopic(updatedCurrentTopic.id);
    }

    getDailyFeedbackReportOnPageLoad = () => {

        ResourceAPIController.getPMDailyFeedbackReportOnPageLoad(this.props.batchCode, this.props.moduleName)
            .then(response => {
                // console.log(' Overall API call response => ', response)

                let feedbackId = '';
                if (!IsObjectEmpty(this.props.params) && !IsStringEmpty(this.props.params.feedbackId)) {
                    feedbackId = parseInt(this.props.params.feedbackId, 10);
                }

                const updatedCurrentTopic = !IsObjectEmpty(response.result.currentTopicDetails) ? response.result.currentTopicDetails : response.result.topicsList[0];

                // console.log('updated current topic >>>', response.result, updatedCurrentTopic);

                const allTopicsList = response.result.topicsList;
                const pos = !IsListEmpty(allTopicsList) ? allTopicsList.findIndex(topic => topic.topicName === updatedCurrentTopic.topicName) : 0;

                this.setState({
                    showTableLoader: false,
                    showCardLoader: false,
                    showOverallCardLoader: false,
                    topicsList: allTopicsList,
                    activeTopicPos: pos,
                    currentTopicDetails: updatedCurrentTopic,
                    currentTopicId: updatedCurrentTopic.id,
                    feedbackTopicsList: response.result.feedbacksList,
                    feedbackType: updatedCurrentTopic.type,
                    feedbackResponses: response.result.feedbackResponses,
                    overallSessionRating: response.result.overallSessionRating,
                    pieChartData: response.result.pieChartData,

                    currentWeekData: response.result.currentWeekData,
                    isLastSessionDataEmpty: response.result.isLastSessionDataEmpty,
                    isDailyDataEmpty: response.result.isDailyDataEmpty,
                    isWeeklyDataEmpty: response.result.isWeeklyDataEmpty,
                });

                // console.log(updatedCurrentTopic.id)
                // if (!IsStringEmpty(feedbackId) && feedbackId > 0) {
                //     const pos = !IsListEmpty(response.result.topicsList)
                //         ? response.result.topicsList.findIndex(topic => topic.id === feedbackId) : 0;

                //     this.dropdownItemClicked(pos);
                // }
            })
            .catch(err => {
                console.log('getDailyFeedbackReportOnPageLoad error => ', err)
                this.setState({ showTableLoader: false, showCardLoader: false, });

            });
    }

    getOverallDailyFeedbackReport = (duration) => {

        ResourceAPIController.getPMOverallFeedbackReport(this.props.batchCode, this.props.moduleName, duration)
            .then(response => {
                // console.log('getPMOverallFeedbackReport response', response.result);
                this.setState({
                    showTableLoader: false,
                    showCardLoader: false,
                    showOverallCardLoader: false,
                    currentWeekData: response.result.currentWeekData,
                    isLastSessionDataEmpty: response.result.isLastSessionDataEmpty,
                    isDailyDataEmpty: response.result.isDailyDataEmpty,
                    isWeeklyDataEmpty: response.result.isWeeklyDataEmpty,
                });
            })
            .catch(err => {
                console.log('getPMOverallFeedbackReport error => ', err)
                if (err.error.status === 404) {
                    this.props.onFailureDialogShow("No sessions found for the selected duration", 'OKAY');
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                this.setState({ showTableLoader: false, showCardLoader: false, showOverallCardLoader: false });
            });
    }

    getDailyFeedbackReportForTopic = (topicId) => {
        ResourceAPIController.getInstructorDailyFeedbackReportForTopic(this.props.batchCode, this.props.moduleName, topicId)
            .then(response => {
                // console.log(response.result)

                this.setState({
                    showTableLoader: false,
                    showCardLoader: false,
                    feedbackResponses: response.result.feedbackResponses,
                    overallSessionRating: response.result.overallSessionRating,
                    pieChartData: response.result.pieChartData,
                    currentTopicDetails: response.result.currentTopicDetails
                })
            })
            .catch(err => {
                console.log('getInstructorDailyFeedbackReportForTopic error => ', err)
                this.props.onFailureDialogShow(err.error.message, 'OKAY');
                this.setState({ showTableLoader: false, showCardLoader: false });
            });
    }

    onViewAllResponsesClicked = () => {
        // console.log("VIEW ALLL RESPONSES CLICKED")
        this.setState({ showStudentsTable: true, showTableLoader: true });
        ResourceAPIController.getDailyFeedbackStudentsListForTopic(this.state.currentTopicId)
            .then(response => {

                this.setState({ showTableLoader: false, studentsList: response.result, fullStudentsList: response.result });

            })
            .catch(err => {
                console.log('getDailyFeedbackStudentsListForTopic error => ', err)
                this.setState({ showTableLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                else if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                else if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }

    showStudentResponsePopup = (userId) => {
        // alert('student response => ' + userId);
        this.setState({ showStudentResponsePopup: true, currentUserId: userId });

    }

    closePopup = () => {
        this.setState({ showStudentResponsePopup: false, currentUserId: 0 });
    }

    componentDidMount() {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (!IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)) {
            this.getDailyFeedbackReportOnPageLoad(batchCode, moduleName);

            let forProgramManager = GetFromLocalStorage(Constants.KEY_IS_PROGRAM_MANAGER) === 'true' ? true : false;
            this.setState({ isProgramManager: forProgramManager, showDurationDropdown: false })
        }
    }

    componentDidUpdate(prevProps) {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (prevProps.batchCode !== this.props.batchCode || prevProps.moduleName !== this.props.moduleName) {
            this.getDailyFeedbackReportOnPageLoad(batchCode, moduleName);
        }
    }

    onDurationDropdownClick = () => {
        this.setState({ showDurationDropdown: !this.state.showDurationDropdown })
    }

    handleSelect = (pos) => {
        let duration = this.state.durationList[pos].value;
        this.setState({ activeItemPos: pos, showOverallCardLoader: true })
        this.getOverallDailyFeedbackReport(duration);

    }

    render() {

        const DurationDropDown = (
            <div className={classes.DurationDropDown}
                onClick={this.onDurationDropdownClick}>
                <span className={[classes.SubHeading, classes.SelectText].join(' ')}>Select Duration</span>&nbsp;&nbsp;
                <img src={DropDownArrow} alt="Select Program Admins"
                    className={[classes.ArrowImg, this.state.showDurationDropdown ? classes.DropDownIconActive : classes.DropDownIcon].join(' ')} width="20" />
                {
                    this.state.showDurationDropdown
                        ? <div className={classes.DropDownContainer} >
                            <DropDownModal
                                itemList={this.state.durationList}
                                modalOpen={false}
                                handleClick={this.handleSelect}
                                itemClicked={this.state.activeItemPos}
                                multiple={false}
                            />
                        </div>
                        : null
                }
            </div>
        )
        const subtopicsResponses = !IsObjectEmpty(this.state.feedbackResponses) && this.state.feedbackResponses.feedbackAvailable && !IsListEmpty(this.state.feedbackResponses.subtopics)
            ? this.state.feedbackResponses.subtopics.map((subtopic, index) => {
                return (
                    <div className={classes.ProgressItem} key={index}>
                        <span>{subtopic.title}</span>
                        <div className={classes.ProgressDiv}>
                            <div className={classes.ProgressBar}>
                                <div className={classes.Progress} style={{ width: subtopic.progressValue + '%' }}>
                                    <span>{subtopic.progressValue + "%"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }) : null;

        const subtopicsResponsesWeek = !IsObjectEmpty(this.state.currentWeekData) && !IsObjectEmpty(this.state.currentWeekData.feedbackResponses) && this.state.currentWeekData.feedbackResponses.feedbackAvailable && !IsListEmpty(this.state.currentWeekData.feedbackResponses.subtopics)
            ? this.state.currentWeekData.feedbackResponses.subtopics.map((subtopic, index) => {
                return (
                    <div className={classes.ProgressItem} key={index}>
                        <span>{subtopic.title}</span>
                        <div className={classes.ProgressDiv}>
                            <div className={classes.ProgressBar}>
                                <div className={classes.Progress} style={{ width: subtopic.progressValue + '%' }}>
                                    <span>{subtopic.progressValue + "%"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }) : null;
        const studentsList = !IsListEmpty(this.state.studentsList) ? this.state.studentsList.map((student, index) => {
            return (
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td className={classes.Link} onClick={() => this.showStudentResponsePopup(student.userId)}>{student.name}</td>
                    <td className={classes.SubmissionTimeTD}>{student.submissionTime}</td>
                    <td className={[classes.Link, classes.CenterAlign].join(' ')} onClick={() => this.showStudentResponsePopup(student.userId)}>Feedback</td>
                </tr>
            );
        }) : null;

        return (
            <div className={classes.DailyFeedbackSectionContainer}>
                {
                    this.state.showStudentResponsePopup
                        ? <StudentResponsePopup
                            show={this.state.showStudentResponsePopup}
                            topicId={this.state.currentTopicId}
                            userId={this.state.currentUserId}
                            closePopup={this.closePopup}
                        />
                        : null
                }
                {/* ----------------------- Topicwise Feedback Report ----------------------- */}
                <h2 className={classes.ReportHeading}>
                    Topicwise Feedback Report
                </h2>

                <div className={classes.DropDownDIv}>
                    <DailyFeedbackDropdown
                        forWeekly={false}
                        dropdownItemsList={this.state.topicsList}
                        activeItemPos={this.state.activeTopicPos}
                        dropdownItemClicked={this.dropdownItemClicked}
                    />
                </div>
                {
                    !this.state.showStudentsTable ?
                        <>
                            {
                                // -------------------- Session Feedback Report Card --------------------
                                this.state.feedbackType === "daily" ?
                                    <DailyFeedbackReportCard
                                        forOverallReport={false}
                                        subtopicsResponses={subtopicsResponses}
                                        showCardLoader={this.state.showCardLoader}
                                        feedbackType={this.state.feedbackType}
                                        isProgramManager={this.state.isProgramManager}
                                        currentTopicDetails={this.state.currentTopicDetails}
                                        overallSessionRating={this.state.overallSessionRating}
                                        feedbackResponses={this.state.feedbackResponses}
                                        pieChartData={this.state.pieChartData}
                                        studentsList={this.state.studentsList}
                                        fullStudentsList={this.state.fullStudentsList}
                                        onViewAllResponsesClicked={this.onViewAllResponsesClicked}
                                        showNoteText={this.state.showNoteText} /> :
                                    <DailyFeedbackReportCard
                                        forOverallReport={false}
                                        areasOfImprovement={subtopicsResponses}
                                        showCardLoader={this.state.showCardLoader}
                                        feedbackType={this.state.feedbackType}
                                        isProgramManager={this.state.isProgramManager}
                                        currentTopicDetails={this.state.currentTopicDetails}
                                        overallSessionRating={this.state.overallSessionRating}
                                        feedbackResponses={this.state.feedbackResponses}
                                        pieChartData={this.state.pieChartData}
                                        onViewAllResponsesClicked={this.onViewAllResponsesClicked}
                                        showNoteText={this.state.showNoteText}
                                    />
                            }

                            <hr className={classes.Divider} />


                            {/* ----------------------- Overall Feedback Report ----------------------- */}

                            <div className={classes.ReportSection}>
                                <h3 className={classes.ReportHeading}>Overall Feedback Report</h3>

                                <div className={classes.DropDownContainerDiv} >
                                    Select a duration to view the overall report data.
                                    {DurationDropDown}
                                </div>

                                {
                                    !IsObjectEmpty(this.state.currentWeekData)
                                        ? <div className={classes.ReportSectionIncludingCharts}>
                                            {
                                                // -------------------- Overall Feedback Report Card --------------------
                                                this.state.feedbackType === "daily" ?
                                                    <DailyFeedbackReportCard
                                                        forOverallReport={true}
                                                        subtopicsResponses={subtopicsResponsesWeek}
                                                        showCardLoader={this.state.showOverallCardLoader}
                                                        feedbackType={this.state.feedbackType}
                                                        isProgramManager={this.state.isProgramManager}
                                                        currentTopicDetails={this.state.currentWeekData.currentTopicDetails}
                                                        overallSessionRating={this.state.currentWeekData.overallSessionRating}
                                                        feedbackResponses={this.state.currentWeekData.feedbackResponses}
                                                        pieChartData={this.state.currentWeekData.pieChartData}
                                                        studentsList={this.state.studentsList}
                                                        fullStudentsList={this.state.fullStudentsList}
                                                        onViewAllResponsesClicked={this.onViewAllResponsesClicked} /> :
                                                    <DailyFeedbackReportCard
                                                        forOverallReport={true}
                                                        areasOfImprovement={subtopicsResponsesWeek}
                                                        showCardLoader={this.state.showOverallCardLoader}
                                                        feedbackType={this.state.feedbackType}
                                                        isProgramManager={this.state.isProgramManager}
                                                        currentTopicDetails={this.state.currentWeekData.currentTopicDetails}
                                                        overallSessionRating={this.state.currentWeekData.overallSessionRating}
                                                        feedbackResponses={this.state.currentWeekData.feedbackResponses}
                                                        pieChartData={this.state.currentWeekData.pieChartData}
                                                        onViewAllResponsesClicked={this.onViewAllResponsesClicked}
                                                    />
                                            }

                                            {/* -------------------- Overall Report - Charts Section -------------------- */}

                                            <div className={classes.ChartsContainer}>
                                                {
                                                    this.state.isDailyDataEmpty === true
                                                        ? null
                                                        : <div className={classes.Chart}>
                                                            <AreaChart
                                                                ratings={this.state.currentWeekData.last7DaysRatings.data}
                                                                labels={this.state.currentWeekData.last7DaysRatings.labels}
                                                            />
                                                            <p className={classes.ChartLabel}>
                                                                {
                                                                    this.state.durationList[this.state.activeItemPos].value === 'overall' ? 'Overall ' : 'LAST 7 DAYS '
                                                                }
                                                                RATING TREND</p>
                                                        </div>
                                                }
                                                {
                                                    this.state.isWeeklyDataEmpty === true
                                                        ? null
                                                        : <div className={classes.Chart}>
                                                            <AreaChart
                                                                ratings={this.state.currentWeekData.weeklyRatings.data}
                                                                labels={this.state.currentWeekData.weeklyRatings.labels}
                                                            />
                                                            <p className={classes.ChartLabel}>WEEKLY RATING TREND</p>
                                                        </div>
                                                }
                                            </div>

                                            <div className={classes.ChartsContainer}>
                                                {
                                                    this.state.isDailyDataEmpty === true || IsObjectEmpty(this.state.currentWeekData) || IsObjectEmpty(this.state.currentWeekData.last7DaysSessionEngagement)
                                                        ? null
                                                        : <div className={classes.Chart}>
                                                            <div className={classes.legend}>
                                                                <p className={classes.BlueBox}></p>
                                                                Engaging
                                                                <p className={classes.OrangeBox}></p>
                                                                Boring
                                                            </div>
                                                            <StackedChart
                                                                labels={this.state.currentWeekData.last7DaysSessionEngagement.labels}
                                                                engagingValues={this.state.currentWeekData.last7DaysSessionEngagement.data.engagingValues}
                                                                boringValues={this.state.currentWeekData.last7DaysSessionEngagement.data.boringValues}
                                                            />
                                                            <p className={classes.ChartLabel}>
                                                                {
                                                                    this.state.durationList[this.state.activeItemPos].value === 'overall' ? 'Overall ' : 'LAST 7 DAYS '
                                                                }  ENGAGING V/S BORING</p>
                                                        </div>
                                                }
                                                {
                                                    this.state.isWeeklyDataEmpty === true || IsObjectEmpty(this.state.currentWeekData) || IsObjectEmpty(this.state.currentWeekData.weeklySessionEngagement)
                                                        ? null
                                                        : <div className={classes.Chart}>
                                                            <div className={classes.legend}>
                                                                <p className={classes.BlueBox}></p>
                                                                Engaging
                                                                <p className={classes.OrangeBox}></p>
                                                                Boring
                                                            </div>
                                                            <StackedChart
                                                                labels={this.state.currentWeekData.weeklySessionEngagement.labels}
                                                                engagingValues={this.state.currentWeekData.weeklySessionEngagement.data.engagingValues}
                                                                boringValues={this.state.currentWeekData.weeklySessionEngagement.data.boringValues}
                                                            />
                                                            <p className={classes.ChartLabel}>WEEKLY ENGAGING V/S BORING</p>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                        : <div className={classes.ChartsContainer}>
                                            Data Not Available!
                                        </div>
                                }

                            </div>

                        </>
                        :
                        <>
                            <div>
                                <table className={classes.Table}>
                                    <thead className={classes.TableHeadings}>
                                        <tr>
                                            <th className={classes.SrNo}>Sr.No.</th>
                                            <th className={classes.StudentNameTH}>
                                                <div className={classes.CenterAlignTh}>
                                                    STUDENT NAME
                                                    <img src={FilterIcon} onClick={this.onNameFilterClicked} alt={'Student Name filter sort icon'} className={classes.FilterIcon} />
                                                    {this.state.showNameFilterDropdown
                                                        ? <div className={classes.Dropdown}>
                                                            <FilterDropDown
                                                                itemList={this.state.nameFilterItems}
                                                                onDropDownClicked={this.onNameFilterClicked}
                                                                onDropDownItemClicked={this.onDropDownItemClicked}
                                                                activeItem={this.state.activeNameFilterDropDownItem}
                                                                searchFieldValue={this.state.nameSearchFieldValue}
                                                                inputChangeHandler={this.nameSearchInputChangeHandler}
                                                                onSearchIconClick={this.onNameSearchIconClick}
                                                                clearSearchResults={this.clearSearchResults}
                                                                searchString={this.state.nameSearchFieldValue}
                                                                forNumber={false}
                                                            />
                                                        </div>
                                                        : null}
                                                </div>
                                            </th>
                                            <th className={classes.SubmissionTimeTH}>SUBMISSION TIME</th>
                                            <th className={classes.ResponseLinkTH}>RESPONSE LINK</th>
                                        </tr>
                                    </thead>
                                    <tbody className={[classes.TableBody, classes.StudentsTable].join(' ')}>

                                        {this.state.showTableLoader
                                            ? <tr>
                                                <td colSpan="4" className={classes.AlignCenter}>
                                                    <ShowMiniLoader isLoading={true} transparentBg={true} />
                                                </td>
                                            </tr>
                                            : !IsListEmpty(studentsList)
                                                ? studentsList
                                                : <tr>
                                                    <td colSpan="4" className={classes.AlignCenter}>Data Not Available!</td>
                                                </tr>}

                                    </tbody>
                                </table>
                            </div>
                        </>

                }


            </div>
        );
    }
}

export default DailyFeedbackSectionNew;